import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = {
  container: {
    position: 'relative'
  },

  loader: {
    zIndex: 10,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}

class ButtonWithLoader extends React.PureComponent {
  render () {
    const {classes, className, loading, color, disabled, onClick, children} = this.props

    const disabledButtonClass = `jr-btn bg-grey text-white`
    const buttonClass = `jr-btn bg-${color} text-white`

    return <div className={`${className} ${classes.container}`}>
      {loading && <CircularProgress size={24} className={classes.loader}/>}
      <Button
        className={disabled || loading ? disabledButtonClass : buttonClass}
        disabled={disabled || loading}
        onClick={onClick}
      >{children}</Button>
    </div>
  }
}

export default withStyles(styles)(ButtonWithLoader)


// WEBPACK FOOTER //
// ./components/ButtonWithLoader/index.js